const backgrounds = [
    "Acolyte",
    "Anthropologist",
    "Archaeologist",
    "Athlete",
    "Charlatan",
    "City Watch",
    "Clan Crafter",
    "Cloistered Scholar",
    "Courtier",
    "Criminal",
    "Entertainer",
    "Faceless",
    "Faction Agent",
    "Failed Merchant",
    "Far Traveler",
    "Feylost",
    "Fisher",
    "Folk Hero",
    "Gambler",
    "Gladiator",
    "Grinner",
    "Guild Artisan",
    "Haunted One",
    "Hermit",
    "House Agent",
    "Inheritor",
    "Investigator",
    "Knight",
    "Marine",
    "Mercenary Veteran",
    "Noble",
    "Outlander",
    "Pirate",
    "Plaintiff",
    "Rival Intern",
    "Sage",
    "Sailor",
    "Shipwright",
    "Smuggler",
    "Soldier",
    "Spy",
    "Urban Bounty Hunter",
    "Urchin",
    "Uthgardt Tribe",
    "Volstrucker Agent",
    "Waterdhavian Agent",
    "Witchlight Hand",
] as const;

export default backgrounds;
